<template>
    <trix-editor
        ref="theEditor"
        @keydown.stop
        @trix-change="handleChange"
        @trix-initialize="initialize"
        @trix-attachment-add="handleAddFile"
        @trix-attachment-remove="handleRemoveFile"
        @trix-file-accept="handleFileAccept"
        :value="value"
        :placeholder="placeholder"
        class="trix-content"
    />
</template>

<script>
import Trix from 'trix'
import 'trix/dist/trix.css'
import Vue from 'vue'

Vue.config.ignoredElements = ['trix-editor']

export default {
    name: 'trix-vue',

    components: { Trix },

    props: {
        name: { type: String },
        value: { type: String, default: '' },
        placeholder: { type: String },
        withFiles: { type: Boolean, default: false },
    },

    methods: {
        initialize() {
            this.$refs.theEditor.editor.insertHTML(this.value)
        },

        handleChange() {
            this.$emit('change', this.$refs.theEditor.value)
        },

        handleFileAccept(e) {
            if (!this.withFiles) {
                e.preventDefault()
            }
        },

        handleAddFile(event) {
            this.$emit('file-add', event)
        },

        handleRemoveFile(event) {
            this.$emit('file-remove', event)
        },
    },

    watch: {
        value: {
            handler(value) {
                if (value != this.$refs.theEditor.value && this.$refs.theEditor.html == '') {
                    this.$refs.theEditor.editor.insertHTML(this.value)
                }
            },
            immediate: false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/TrixBase.vue